import styled from 'styled-components'
import { DolaThemes } from '../../../styles/types'
import { borderRadius } from '../../../styles/variables'
import { ButtonVariants } from '../types'
import buttonTheme from './theme'
import theme from './theme'

export interface BaseButtonProps {
  isLoading?: boolean
  dolaTheme: DolaThemes
  variant?: ButtonVariants
}

const ButtonOverlay = styled.span<BaseButtonProps>`
  align-items: center;
  color: ${({ dolaTheme, variant = 'primary' }) =>
    buttonTheme[dolaTheme][variant].text};
  cursor: ${({ isLoading }) => (isLoading ? 'progress' : 'pointer')};
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
  ${borderRadius};
  ${({ dolaTheme, variant = 'primary' }) => `
      background: ${theme[dolaTheme][variant].background};
  `}
`

export default ButtonOverlay
